import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";
import { store } from "./redux/store/store";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import { createBrowserHistory } from "history";
import ReactGA from "react-ga4";

ReactGA.initialize("G-J8Z159JXQH");

const root = ReactDOM.createRoot(document.getElementById("root"));
const history = createBrowserHistory();

root.render(
  <Provider store={store}>
    <BrowserRouter history={history}>
      <App />
    </BrowserRouter>
  </Provider>
);
/*
ReactDOM.render(

<React.StrictMode>
    
    <Provider store={store}>
      <App/>

    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
*/

reportWebVitals();
serviceWorker.unregister();
